import { GetServerSideProps, NextPage } from "next";
import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { SpWindow } from "../../components/front/lp/sydm2/SpWindow";
import useTheme from "@material-ui/core/styles/useTheme";
import { useMediaQuery } from "@material-ui/core";
import { SYDM2_SLUG } from "../../components/front/lp/sydm2/constants";
import Link from "next/link";
import { Sydm2LpHead } from "../../components/front/lp/sydm2/Sydm2LpHead";
import { GeneralFoot } from "../../components/front/layout/GeneralFoot";
import { UnSupportError } from "../../components/front/error/UnSupportError";
import { useSupportBrowser } from "../../lib/hooks/useSupportBrowser";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("md")]: {
      backgroundSize: "contain",
      backgroundImage: "url(/img/lp/background.jpg)",
      height: "100vh",
      overflow: "scroll",
      minHeight: "540px",
      ["@media (min-height:993.75px)"]: {
        display: "flex",
        alignItems: "center",
      },
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  courseTag: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    position: "absolute",
    left: 0,
    width: "5%",
    cursor: "pointer",
  },
  tag1: {
    left: "5.5%",
    top: "25%",
    width: "21%",
  },
  tag2: {
    left: "16.5%",
    top: "53%",
    width: "15.7%",
  },
  tag3: {
    left: "38%",
    top: "6.5%",
    width: "18.2%",
  },
  tag4: {
    left: "50.5%",
    top: "25%",
    width: "17%",
  },
  tag5: {
    left: "38.5%",
    top: "56.8%",
    width: "18.2%",
  },
  pcWindow: {
    [theme.breakpoints.up("md")]: {
      position: "relative",
      maxWidth: "1920px",
      minWidth: "1660px",
      overflow: "scroll",
      width: "100%",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  pcBackground: {
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  annotationArea: {
    position: "absolute",
    bottom: "40px",
    left: "70px",
    fontSize: "11px",
  },
}));

type Props = {};
const LpSydm2: NextPage<Props> = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isPc = useMediaQuery(theme.breakpoints.up("md"));
  const supportBrowser = useSupportBrowser();
  return (
    <>
      <Sydm2LpHead />
      {supportBrowser === true && (
        <div className={classes.root}>
          <div className={isPc ? classes.pcWindow : ""}>
            {isPc && (
              <>
                <Link href={`/project/${SYDM2_SLUG}`}>
                  <img src={"/img/lp/note_course1.png"} className={`${classes.courseTag} ${classes.tag1}`} />
                </Link>
                <Link href={`/project/${SYDM2_SLUG}`}>
                  <img src={"/img/lp/note_course2.png"} className={`${classes.courseTag} ${classes.tag2}`} />
                </Link>
                <Link href={`/project/${SYDM2_SLUG}`}>
                  <img src={"/img/lp/note_course3.png"} className={`${classes.courseTag} ${classes.tag3}`} />
                </Link>
                <Link href={`/project/${SYDM2_SLUG}`}>
                  <img src={"/img/lp/note_course4.png"} className={`${classes.courseTag} ${classes.tag4}`} />
                </Link>
                <Link href={`/project/${SYDM2_SLUG}`}>
                  <img src={"/img/lp/note_course5.png"} className={`${classes.courseTag} ${classes.tag5}`} />
                </Link>
                <img src={"/img/lp/note_phone.png"} className={classes.pcBackground} />
                <div className={classes.annotationArea}>
                  ※コースの画像はイメージです。実際の商品とはデザインが異なることがあります。
                  <br />
                  ※詳細・注意事項は本サイトでご確認ください。
                  <br />
                  ※値段表記は税込価格です。
                </div>
              </>
            )}
            <SpWindow />
          </div>
        </div>
      )}
      {supportBrowser === false && <UnSupportError />}
      <GeneralFoot />
    </>
  );
};

export const getServerSideProps: GetServerSideProps<Props> = async () => {
  return { props: {} };
};

export default LpSydm2;
